<template>
  <div>
    <el-table
      v-if="invoices.length"
      :data="invoices"
      border
      style="width: 100%"
      row-key="invoice_id"
    >
      <el-table-column
        prop="invoice_number"
        label="Invoice Number"
        width="150"
      />
      <el-table-column
        prop="type"
        label="Type"
        width="100"
      />
      <el-table-column
        prop="date"
        label="Date"
        width="120"
        :formatter="format_date"
      />
      <el-table-column
        prop="due_date"
        label="Due Date"
        width="120"
        :formatter="format_date"
      />
      <el-table-column
        prop="status"
        label="Status"
        width="100"
      />
      <el-table-column
        prop="total"
        label="Total"
        width="120"
      />
    </el-table>

    <div v-else>
      <p>No invoices to display.</p>
    </div>
  </div>
</template>

<script>
import { xero_invoices } from '../../api/xero';
export default {
  name: 'XeroInvoices',
  props: {
    contact: { type: Object, required: true }
  },
  data() {
    return {
      invoices: [],
      loading: false
    };
  },
  mounted() {
    this.fetch_invoices();
  },
  methods: {
    async fetch_invoices() {
      if (!this.contact) return;
      this.loading = true;
      try {
        const response = await xero_invoices(this, { contact_id: this.contact.contact_id });
        this.invoices = response.data.invoices || [];
      } catch (err) {
        console.error('Failed to fetch Xero invoices', err);
      } finally {
        this.loading = false;
      }
    },
    format_date(row, column, cellValue) {
      if (typeof cellValue === 'string') {
        const match = /\/Date\((\d+)([+-]\d+)?\)\//.exec(cellValue);
        if (match) {
          const ts = parseInt(match[1], 10);
          return new Date(ts).toLocaleString();
        }
      }
      return cellValue || '';
    }
  }
};
</script>
